import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout, ConfigProvider } from 'antd';
import { ArticleProvider } from './api/ArticleContext2';
import { UserProvider } from './api/UserContext';

// 导入组件
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/footer';
import Home from './pages/Home/Home';
import Archive from './pages/Archive/Archive';
import ArticleDetail from './pages/ArticleDetail/ArticleDetail';
import WriteArticle from './pages/WriteArticle/WriteArticle';
import Profile from './pages/Profile/Profile';
import Auth from './pages/Auth/Auth';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';

// 导入样式
import './App.css';

// 创建简单的占位符组件
const Search = () => (
  <div style={{ padding: '40px', textAlign: 'center' }}>
    <h2>搜索功能开发中...</h2>
    <p>即将推出强大的文章搜索功能</p>
  </div>
);

const Settings = () => (
  <div style={{ padding: '40px', textAlign: 'center' }}>
    <h2>系统设置</h2>
    <p>系统设置页面正在开发中</p>
  </div>
);

const About = () => (
  <div style={{ padding: '40px', textAlign: 'center' }}>
    <h2>关于我们</h2>
    <p>一个专注于技术分享的个人博客平台</p>
  </div>
);

const Notifications = () => (
  <div style={{ padding: '40px', textAlign: 'center' }}>
    <h2>通知中心</h2>
    <p>暂无新通知</p>
  </div>
);

const { Content } = Layout;

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
          borderRadius: 6,
          colorBgContainer: '#ffffff',
        },
        components: {
          Layout: {
            bodyBg: '#f0f2f5',
            headerBg: '#ffffff',
          },
          Card: {
            borderRadiusLG: 8,
          },
        },
      }}
    >
      <Router>
        <ArticleProvider>
          <UserProvider>
            <Layout style={{ minHeight: '100vh' }}>
              <Navbar />
              <Content style={{ padding: '0 50px', marginTop: 64, background: '#fafafa' }}>
                <div style={{ minHeight: 380 }}>
                  <Routes>
                    {/* 公开路由 */}
                    <Route path="/" element={<Home />} />
                    <Route path="/post/:id" element={<ArticleDetail />} />
                    <Route path="/article/:id" element={<ArticleDetail />} />
                    <Route path="/archive" element={<Archive />} />
                    <Route path="/auth" element={<Auth />} />
                    <Route path="/search" element={<Search />} />
                    <Route path="/about" element={<About />} />
                    
                    {/* 需要登录的受保护路由 */}
                    <Route path="/write" element={
                      <PrivateRoute>
                        <WriteArticle />
                      </PrivateRoute>
                    } />
                    <Route path="/write/:id" element={
                      <PrivateRoute>
                        <WriteArticle />
                      </PrivateRoute>
                    } />
                    <Route path="/profile" element={
                      <PrivateRoute>
                        <Profile />
                      </PrivateRoute>
                    } />
                    <Route path="/settings" element={
                      <PrivateRoute>
                        <Settings />
                      </PrivateRoute>
                    } />
                    <Route path="/notifications" element={
                      <PrivateRoute>
                        <Notifications />
                      </PrivateRoute>
                    } />
                    
                    {/* 404路由 */}
                    <Route path="*" element={
                      <div style={{ padding: '80px', textAlign: 'center' }}>
                        <h2>404 - 页面未找到</h2>
                        <p>您访问的页面不存在</p>
                      </div>
                    } />
                  </Routes>
                </div>
              </Content>
              <Footer />
            </Layout>
          </UserProvider>
        </ArticleProvider>
      </Router>
    </ConfigProvider>
  );
}

export default App;